import { createStore } from 'vuex'
import { ShippingStep, UploadDataType } from '@/const/const'

const state = {
  record: [],
  uploadDataType: UploadDataType.None,
  uploadedAmazonIsbn: false,
  stepStatus: ShippingStep.Step1
}

const getters = {
  uploadDataType: state => {
    return state.uploadDataType
  },
  stepStatus: state => {
    return state.stepStatus
  },
  isUploadedShippingData: state => {
    return state.record.length > 0
  },
  getShippingData: state => {
    return state.record
  },
  getReceiptData: state => {
    return state.record.filter(x => x.checkedStep4)
  },
  uploadedAmazonIsbn: state => {
    return state.uploadedAmazonIsbn
  },
  shippingImage: state => {
    let path

    switch (state.stepStatus.Index) {
      case ShippingStep.Step1.Index:
        path = require('@/assets/shipping/step1.png')
        break
      case ShippingStep.Step2.Index:
        path = require('@/assets/shipping/step2.png')
        break
      case ShippingStep.Step3.Index:
        path = require('@/assets/shipping/step3.png')
        break
      case ShippingStep.Step4.Index:
        path = require('@/assets/shipping/step4.png')
        break
    }
    return path
  }
}
const actions = {
}
const mutations = {
  setStepStatus (state, p) {
    console.log('setstepstatus')
    console.log(p)
    state.stepStatus = p
  },
  setShippingData (state, p) {
    console.log('set shippingdata complete')
    state.record = p.data
    state.uploadDataType = p.type
  },
  // amazon用 isbnセット
  setIsbnData (state, p) {
    const isbnData = p.data
    state.record.forEach(x => {
      x.items.forEach(y => {
        const sku = y.sku
        if (isbnData.some(r => r.sku === sku)) {
          const target = isbnData.find(r => r.sku === sku)
          y.isbn = target.isbn
        }
      })
    })
    console.log(state.record)
  },
  changedStep (state, p) {
    console.log('changedStep')
    // console.log(router)
    console.log(state.stepStatus.Index)
    console.log(ShippingStep.Step1.Index)
    switch (state.stepStatus.Index) {
      case ShippingStep.Step1.Index:
        // state.stepStatus = ShippingStep.Step2
        // router.push({ name: 'Step2' })
        break
      case ShippingStep.Step2.Index: {
        // router.push({ name: 'Step3' })

        // 独立した配列をコピー
        const tmp1 = state.record.slice(0, state.record.length)
        const tmp = tmp1.filter(x => x.checked === true)

        console.log(tmp)

        // 最後に移動&並び替え
        tmp.sort((a, b) => a.items.length - b.items.length)
        tmp.sort((a, b) => a.items[0].sku - b.items[0].sku)
        state.record = tmp

        break
      }
      case ShippingStep.Step3.Index:
        // state.stepStatus = ShippingStep.Step4
        // router.push({ name: 'Step4' })
        break
      case ShippingStep.Step4.Index:
        // 完了処理
        break
    }
  },
  // step2のチェック更新
  updateShippingRecord (state, p) {
    p.row.checked = !p.row.checked
  },
  // step2からstep3への更新
  updateShippingStep2ToStep3 (state) {
    // 独立した配列をコピー
    console.log(state.record)
    let tmp = state.record.slice(0, state.record.length)

    tmp = tmp.filter(x => x.checked === true)

    tmp.forEach((x, index) => {
      x.index = index + 1
    })

    console.log(tmp)

    // 最後に移動&並び替え
    // tmp.sort((a, b) => a.items.length - b.items.length)
    // tmp.sort((a, b) => a.items[0].sku - b.items[0].sku)
    state.record = tmp
  },
  // step3のチェック更新
  updateStep3Check (state, p) {
    p.row.checkedStep3 = !p.row.checkedStep3
  },
  // step4のチェック更新
  updateStep4Check (state, p) {
    p.row.checkedStep4 = !p.row.checkedStep4
  },
  updateEditorShippingRecord (state, p) {
    p.targetRecord.recipientName = p.record.recipientName
    p.targetRecord.shipPostalCode = p.record.shipPostalCode
    p.targetRecord.shipState = p.record.shipState
    p.targetRecord.shipCity = p.record.shipCity
    p.targetRecord.shipAddress1 = p.record.shipAddress1
    p.targetRecord.shipAddress2 = p.record.shipAddress2
    p.targetRecord.shipAddress3 = p.record.shipAddress3
    p.targetRecord.shipMethod = p.record.shipMethod
    p.targetRecord.memo = p.record.memo
    p.targetRecord.manualSelectMemo = p.record.manualSelectMemo
    console.log(state.record)
  }
}

export default createStore({
  state,
  getters,
  actions,
  mutations
})
